export { AboutPage as default } from "@nvb/ui";
